import React from 'react'

import { LntDrawer } from '@app/components/base'

import { CommonQuotaForm } from './CommonQuotaForm'

import type { ProductsFormData, CommonQuotaDrawerProps } from './types'

export const CommonQuotaDrawer: React.FC<CommonQuotaDrawerProps> = props => {
  const { dataSource, onSubmit, onClose, isEditForm, ...restProps } = props

  const handleSubmit = (data: ProductsFormData): void => {
    const { hierarchyKey, hierarchyValues, ...restData } = data
    const isHierarchyExist = hierarchyKey?.length && hierarchyValues?.length

    const hierarchyObject = isHierarchyExist ? { [hierarchyKey]: hierarchyValues } : {}

    onSubmit?.({
      ...restData,
      ...hierarchyObject
    })
  }

  return (
    <LntDrawer
      { ...restProps }
      width={ 424 }
      onClose={ onClose }
    >
      <CommonQuotaForm
        dataSource={ dataSource }
        isEditForm={ isEditForm }
        onClose={ onClose }
        onSubmit={ handleSubmit }
      />
    </LntDrawer>
  )
}
